// Debug utility for tracking infinite loop issues
// Enable with ?vb_debug=1 in URL or localStorage.setItem('vb_debug', '1')

export const DEBUG =
  import.meta.env.DEV &&
  (window.location.search.includes('vb_debug=1') || localStorage.getItem('vb_debug') === '1');

let renderCount = 0;
const componentRenderCounts = new Map<string, number>();
const componentStateSnapshots = new Map<string, any[]>();

export function logRender(componentName: string, props?: any, state?: any) {
  if (!DEBUG) return;

  renderCount++;
  const count = (componentRenderCounts.get(componentName) || 0) + 1;
  componentRenderCounts.set(componentName, count);

  // Store state snapshot
  const snapshots = componentStateSnapshots.get(componentName) || [];
  const snapshot = {
    renderNumber: count,
    timestamp: Date.now(),
    props: props ? JSON.parse(JSON.stringify(props)) : undefined,
    state: state ? JSON.parse(JSON.stringify(state)) : undefined,
  };
  snapshots.push(snapshot);
  componentStateSnapshots.set(componentName, snapshots);

  console.log(
    `%c[RENDER #${renderCount}] ${componentName} (${count}x)`,
    'background: #ff6b6b; color: white; padding: 2px 6px; border-radius: 3px;',
    { props, state }
  );

  // Detect infinite loops (more than 50 renders)
  if (count > 50) {
    console.error(
      `%c🚨 INFINITE LOOP DETECTED: ${componentName} rendered ${count} times!`,
      'background: red; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold;'
    );

    // Analyze state changes
    if (snapshots.length > 2) {
      const recent = snapshots.slice(-3);
      console.group(`State changes in ${componentName}:`);
      recent.forEach((snap, i) => {
        console.log(`Render #${snap.renderNumber}:`, snap);
      });
      console.groupEnd();
    }
  }
}

export function getDebugReport() {
  return {
    totalRenders: renderCount,
    componentRenderCounts: Object.fromEntries(componentRenderCounts),
    componentStateSnapshots: Object.fromEntries(componentStateSnapshots),
  };
}

export function resetDebugCounters() {
  renderCount = 0;
  componentRenderCounts.clear();
  componentStateSnapshots.clear();
  console.log('%c[DEBUG] Counters reset', 'color: green;');
}

// Global debug helpers
if (DEBUG) {
  (window as any).vbDebug = {
    getReport: getDebugReport,
    reset: resetDebugCounters,
    enable: () => localStorage.setItem('vb_debug', '1'),
    disable: () => localStorage.removeItem('vb_debug'),
  };

  console.log(
    '%c🐛 ViewsBoost Debug Mode Enabled',
    'background: #4a90e2; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold;'
  );
  console.log('Use window.vbDebug.getReport() to see render stats');
  console.log('Use window.vbDebug.reset() to reset counters');
}
